import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitofivejyotilingacab() {



    const cardData = {

keyword: "Mumbai to 5 Jyotirlinga Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to 5 Jyotirlinga Cab services for devotees, families, senior citizens, and pilgrimage groups seeking a sacred journey across Maharashtra. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth and spiritually fulfilling trip. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip bookings, customizable pilgrimage itineraries, 24/7 customer support, and transparent pricing, we ensure a hassle-free 5 Jyotirlinga Yatra covering the holy shrines of Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath along with important spiritual and cultural attractions.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar Jyotirlinga, located near Nashik, is one of the twelve sacred Jyotirlingas of Lord Shiva and is situated at the foothills of the Brahmagiri Mountains. The temple is famous for its unique three-faced lingam representing Brahma, Vishnu, and Mahesh. Pilgrims visit throughout the year to perform religious rituals, seek blessings, and experience the peaceful spiritual atmosphere surrounding this holy shrine."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar Jyotirlinga is nestled in the Sahyadri hills and is one of Maharashtra's most important pilgrimage destinations. Surrounded by dense forests and wildlife sanctuary areas, the temple combines natural beauty with deep religious significance. Devotees come to worship Lord Shiva while enjoying the serene environment and sacred traditions associated with this ancient temple."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Jyotirlinga, located near the Ellora Caves, is the twelfth Jyotirlinga and an important stop in the Maharashtra Jyotirlinga circuit. The temple is admired for its beautifully carved stone architecture and spiritual importance. Pilgrims often combine their visit with Ellora and other nearby heritage sites to create a memorable religious journey."
    },
    {
        title: "Aundha Nagnath Jyotirlinga",
        description:
            "Aundha Nagnath is believed by many devotees to be one of the oldest Jyotirlinga temples in India. The ancient temple showcases remarkable Hemadpanthi architecture and features intricate carvings reflecting centuries of history and devotion. Pilgrims visit to seek Lord Shiva's blessings while appreciating the temple's peaceful and sacred atmosphere."
    },
    {
        title: "Parli Vaijnath Jyotirlinga",
        description:
            "Parli Vaijnath Jyotirlinga is a highly revered Shiva temple known for its religious significance and beautiful hilltop location. According to Hindu traditions, worship at this temple is believed to bring health, prosperity, and spiritual well-being. The temple's architectural beauty and devotional environment attract thousands of pilgrims every year."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are a UNESCO World Heritage Site and one of India's greatest archaeological treasures. The rock-cut caves feature Buddhist, Hindu, and Jain monuments, including the magnificent Kailasa Temple carved from a single rock. Pilgrims and tourists visiting Grishneshwar often include Ellora to experience its extraordinary art, architecture, and historical significance."
    },
    {
        title: "Brahmagiri Hills and Godavari Origin",
        description:
            "The Brahmagiri Hills near Trimbakeshwar are considered sacred as the origin of the holy Godavari River. The area is surrounded by scenic landscapes, ancient temples, and trekking routes that attract both pilgrims and nature lovers. Visitors experience a unique blend of spirituality and natural beauty during their Jyotirlinga pilgrimage."
    },
    {
        title: "Bhimashankar Wildlife Sanctuary",
        description:
            "The Bhimashankar Wildlife Sanctuary surrounds the Bhimashankar Temple and is known for its rich biodiversity, dense forests, and the rare Indian Giant Squirrel. The sanctuary offers scenic landscapes and peaceful surroundings that enhance the spiritual experience of visiting the Jyotirlinga while also attracting nature enthusiasts."
    },
    {
        title: "Parbhani and Nanded Spiritual Circuit",
        description:
            "The route connecting Aundha Nagnath and Parli Vaijnath passes through historically and spiritually significant regions of Maharashtra. Travelers often visit nearby temples, gurudwaras, and cultural landmarks while exploring the heritage of the Marathwada region, adding greater depth to the pilgrimage experience."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi Sai Baba Temple is one of India's most visited pilgrimage destinations and is frequently included in a 5 Jyotirlinga tour from Mumbai. Devotees seek the blessings of Sai Baba and visit sacred places such as Dwarkamai, Chavadi, and Lendi Baug. Combining Shirdi with the Jyotirlinga circuit creates a spiritually fulfilling journey across Maharashtra."
    }
],



services: [
{
name: "Mumbai to 5 Jyotirlinga Cab",
description: "Mumbai Airport Cab offers Mumbai to 5 Jyotirlinga Cab service for a comfortable and spiritually enriching pilgrimage across Maharashtra's five sacred Jyotirlinga temples including Bhimashankar, Trimbakeshwar, Grishneshwar, Parli Vaijnath, and Aundha Nagnath. Our AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles are ideal for families, senior citizens, groups, and religious travellers. We provide customized itineraries, experienced chauffeurs, doorstep pickup, flexible schedules, one way and round trip packages, and 24x7 booking support for a peaceful and memorable Jyotirlinga Yatra."
},
{
name: "Mumbai to 5 Jyotirlinga Tour Package",
description: "Book Mumbai to 5 Jyotirlinga Tour Package with Mumbai Airport Cab for a complete pilgrimage experience covering all major Jyotirlinga temples in Maharashtra. Our package includes comfortable transportation, professional drivers, flexible sightseeing schedules, and premium vehicles suitable for family and group travel."
},
{
name: "Mumbai to 5 Jyotirlinga Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to 5 Jyotirlinga Taxi Service with safe and reliable chauffeur-driven vehicles for devotees planning a sacred temple journey. Enjoy transparent pricing, AC comfort, experienced drivers, and customized travel plans."
},
{
name: "Mumbai to 5 Jyotirlinga Cab Service",
description: "Choose Mumbai to 5 Jyotirlinga Cab Service for convenient long-distance pilgrimage travel with Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, and luxury vehicle options designed for comfortable temple visits."
},
{
name: "Mumbai to 5 Jyotirlinga Darshan Package",
description: "Mumbai Airport Cab offers Mumbai to 5 Jyotirlinga Darshan Package with carefully planned temple routes, flexible travel schedules, premium vehicles, and experienced chauffeurs to ensure a smooth spiritual journey."
},
{
name: "Mumbai to 5 Jyotirlinga Yatra Cab",
description: "Book Mumbai to 5 Jyotirlinga Yatra Cab for a comfortable pilgrimage covering Maharashtra's sacred Jyotirlinga temples with professional drivers, AC vehicles, and affordable travel packages."
},
{
name: "Mumbai to 5 Jyotirlinga Tour Cab",
description: "Mumbai Airport Cab provides Mumbai to 5 Jyotirlinga Tour Cab with customized pilgrimage itineraries, comfortable seating, and reliable transportation for families and religious groups."
},
{
name: "Mumbai to 5 Jyotirlinga Taxi",
description: "Travel with Mumbai to 5 Jyotirlinga Taxi from Mumbai Airport Cab and enjoy safe, comfortable, and affordable transportation with experienced chauffeurs and premium vehicles."
},
{
name: "Mumbai to 5 Jyotirlinga Car Rental",
description: "Mumbai Airport Cab offers Mumbai to 5 Jyotirlinga Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury cars suitable for pilgrimage tours and family travel."
},
{
name: "Mumbai to 5 Jyotirlinga Package by Cab",
description: "Book Mumbai to 5 Jyotirlinga Package by Cab for a complete religious tour with customized travel plans, premium vehicles, and professional drivers dedicated to a hassle-free pilgrimage."
},
{
name: "Mumbai to 5 Jyotirlinga Innova Cab",
description: "Mumbai Airport Cab provides Mumbai to 5 Jyotirlinga Innova Cab service with spacious interiors, comfortable seating, and reliable travel for family and group temple tours."
},
{
name: "Mumbai to 5 Jyotirlinga Innova Crysta Cab",
description: "Choose Mumbai to 5 Jyotirlinga Innova Crysta Cab for a premium pilgrimage experience with luxury seating, ample luggage space, professional chauffeurs, and smooth long-distance travel."
},
{
name: "Mumbai to 5 Jyotirlinga Ertiga Cab",
description: "Mumbai Airport Cab offers Mumbai to 5 Jyotirlinga Ertiga Cab for economical and comfortable family travel with AC comfort, experienced drivers, and flexible travel plans."
},
{
name: "Mumbai to 5 Jyotirlinga Kia Carens Cab",
description: "Book Mumbai to 5 Jyotirlinga Kia Carens Cab with Mumbai Airport Cab for spacious and comfortable family travel featuring premium interiors and reliable chauffeur service."
},
{
name: "Mumbai to 5 Jyotirlinga SUV Taxi",
description: "Mumbai Airport Cab provides Mumbai to 5 Jyotirlinga SUV Taxi service for larger groups seeking spacious seating, premium comfort, and safe pilgrimage transportation."
},
{
name: "Mumbai to 5 Jyotirlinga Sedan Cab",
description: "Travel with Mumbai to 5 Jyotirlinga Sedan Cab for affordable and comfortable pilgrimage journeys suitable for couples, individuals, and small families."
},
{
name: "Mumbai to 5 Jyotirlinga Tempo Traveller",
description: "Mumbai Airport Cab offers Mumbai to 5 Jyotirlinga Tempo Traveller service for large family groups, pilgrimage tours, and religious events with spacious seating and experienced drivers."
},
{
name: "Mumbai to 5 Jyotirlinga Luxury Cab",
description: "Book Mumbai to 5 Jyotirlinga Luxury Cab for an elegant pilgrimage experience with premium vehicles, personalized service, and maximum travel comfort."
},
{
name: "Mumbai to 5 Jyotirlinga AC Taxi",
description: "Mumbai Airport Cab provides Mumbai to 5 Jyotirlinga AC Taxi service with clean, air-conditioned vehicles and professional chauffeurs for comfortable temple travel."
},
{
name: "Mumbai to 5 Jyotirlinga Family Tour Cab",
description: "Choose Mumbai to 5 Jyotirlinga Family Tour Cab for a safe and memorable pilgrimage with spacious vehicles, customized itineraries, and family-friendly travel arrangements."
},
{
name: "Mumbai to Bhimashankar Cab",
description: "Mumbai Airport Cab offers Mumbai to Bhimashankar Cab service with safe and reliable transportation to one of Maharashtra's most sacred Jyotirlinga temples."
},
{
name: "Mumbai to Trimbakeshwar Cab",
description: "Book Mumbai to Trimbakeshwar Cab with Mumbai Airport Cab for comfortable and affordable travel to the famous Jyotirlinga shrine near Nashik."
},
{
name: "Mumbai to Grishneshwar Cab",
description: "Mumbai Airport Cab provides Mumbai to Grishneshwar Cab service with premium vehicles and experienced chauffeurs for pilgrimage and sightseeing tours."
},
{
name: "Mumbai to Parli Vaijnath Cab",
description: "Travel with Mumbai to Parli Vaijnath Cab from Mumbai Airport Cab for convenient temple visits with comfortable vehicles and customized travel schedules."
},
{
name: "Mumbai to Aundha Nagnath Cab",
description: "Mumbai Airport Cab offers Mumbai to Aundha Nagnath Cab service for safe and affordable pilgrimage travel with professional drivers and premium AC vehicles."
},
{
name: "Mumbai to Bhimashankar Trimbakeshwar Tour",
description: "Book Mumbai to Bhimashankar Trimbakeshwar Tour with Mumbai Airport Cab for a spiritual journey covering two sacred Jyotirlinga temples with customized travel plans."
},
{
name: "Mumbai to Grishneshwar Jyotirlinga Taxi",
description: "Mumbai Airport Cab provides Mumbai to Grishneshwar Jyotirlinga Taxi service with comfortable vehicles and dependable transportation for religious travellers."
},
{
name: "Mumbai to Parli Vaijnath Tour Package",
description: "Choose Mumbai to Parli Vaijnath Tour Package for a complete pilgrimage experience with premium vehicles, professional chauffeurs, and flexible travel schedules."
},
{
name: "Mumbai to Aundha Nagnath Darshan Cab",
description: "Mumbai Airport Cab offers Mumbai to Aundha Nagnath Darshan Cab with reliable transportation and comfortable vehicles for devotees visiting the sacred temple."
},
{
name: "Maharashtra 5 Jyotirlinga Tour from Mumbai",
description: "Mumbai Airport Cab provides Maharashtra 5 Jyotirlinga Tour from Mumbai with complete pilgrimage packages covering all five sacred Jyotirlinga temples in comfortable AC vehicles with experienced chauffeurs and customized itineraries."
}
],

tableData: [
["Mumbai to 5 Jyotirlinga Cab","Mumbai to 5 Jyotirlinga Tour Package"],
["Mumbai to 5 Jyotirlinga Taxi Service","Mumbai to 5 Jyotirlinga Cab Service"],
["Mumbai to 5 Jyotirlinga Darshan Package","Mumbai to 5 Jyotirlinga Yatra Cab"],
["Mumbai to 5 Jyotirlinga Tour Cab","Mumbai to 5 Jyotirlinga Taxi"],
["Mumbai to 5 Jyotirlinga Car Rental","Mumbai to 5 Jyotirlinga Package by Cab"],
["Mumbai to 5 Jyotirlinga Innova Cab","Mumbai to 5 Jyotirlinga Innova Crysta Cab"],
["Mumbai to 5 Jyotirlinga Ertiga Cab","Mumbai to 5 Jyotirlinga Kia Carens Cab"],
["Mumbai to 5 Jyotirlinga SUV Taxi","Mumbai to 5 Jyotirlinga Sedan Cab"],
["Mumbai to 5 Jyotirlinga Tempo Traveller","Mumbai to 5 Jyotirlinga Luxury Cab"],
["Mumbai to 5 Jyotirlinga AC Taxi","Mumbai to 5 Jyotirlinga Family Tour Cab"],
["Mumbai to Bhimashankar Cab","Mumbai to Trimbakeshwar Cab"],
["Mumbai to Grishneshwar Cab","Mumbai to Parli Vaijnath Cab"],
["Mumbai to Aundha Nagnath Cab","Mumbai to Bhimashankar Trimbakeshwar Tour"],
["Mumbai to Grishneshwar Jyotirlinga Taxi","Mumbai to Parli Vaijnath Tour Package"],
["Mumbai to Aundha Nagnath Darshan Cab","Maharashtra 5 Jyotirlinga Tour from Mumbai"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to 5 Jyotirlinga Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to 5 Jyotirlinga Cab transportation for devotees, families, senior citizens, pilgrimage groups, and spiritual travelers seeking a comfortable religious journey."
},
{
WhyChooseheading: "Complete Jyotirlinga Darshan Tour",
WhyChoosedescription: "Our cab service offers convenient travel to five sacred Jyotirlingas including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath with well-planned itineraries."
},
{
WhyChooseheading: "Perfect for Religious Pilgrimage Travel",
WhyChoosedescription: "Thousands of devotees choose our Mumbai to 5 Jyotirlinga Cab Service for spiritual tours, temple visits, family pilgrimages, and religious group travel."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on passenger count and travel preferences."
},
{
WhyChooseheading: "Customized Tour Packages",
WhyChoosedescription: "Whether you require a 2-day, 3-day, 4-day, or customized Jyotirlinga package, we provide flexible travel solutions according to your schedule."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Experienced Drivers",
WhyChoosedescription: "Our professional drivers are familiar with all Jyotirlinga routes and ensure safe, comfortable, and hassle-free travel throughout the pilgrimage."
},
{
WhyChooseheading: "Suitable for Families and Religious Groups",
WhyChoosedescription: "From individual devotees to large pilgrimage groups, we offer suitable vehicle options for a memorable and comfortable spiritual journey."
}
]
};

const faqData = [
{
question: "Which temples are included in the Mumbai to 5 Jyotirlinga Cab Tour?",
answer: "The tour generally includes Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlinga temples."
},
{
question: "Can I customize my 5 Jyotirlinga tour itinerary?",
answer: "Yes, customers can customize travel schedules, temple sequences, sightseeing locations, and overnight stay plans."
},
{
question: "Which vehicle is suitable for 5 Jyotirlinga travel?",
answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices for comfortable long-distance pilgrimage travel."
},
{
question: "Are round-trip packages available from Mumbai?",
answer: "Yes, complete round-trip Jyotirlinga Darshan packages are available with flexible travel durations."
},
{
question: "Can families book this service for pilgrimage tours?",
answer: "Yes, families frequently choose our Mumbai to 5 Jyotirlinga Cab Service for comfortable and convenient religious travel."
},
{
question: "Do you provide Tempo Travellers for groups?",
answer: "Yes, Tempo Travellers and larger vehicles are available for pilgrimage groups, family tours, and spiritual organizations."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance reservation recommended for Jyotirlinga tours?",
answer: "Yes, advance booking helps secure preferred vehicles and allows better planning for temple visits and accommodations."
},
{
question: "Can additional temples be included during the trip?",
answer: "Yes, customers can include Shirdi, Shani Shingnapur, Tuljapur, Akkalkot, and other religious destinations in their itinerary."
},
{
question: "How can I book a Mumbai to 5 Jyotirlinga Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Ashok Patwardhan",
feedback:
"Our Mumbai to 5 Jyotirlinga pilgrimage was very comfortable with Mumbai Airport Cab Service. The vehicle was clean, the driver was experienced, and the entire journey was perfectly organized.",
rating: 5
},
{
id: 2,
name: "Mrs. Sujata Deshmukh",
feedback:
"We completed all five Jyotirlinga darshans smoothly with our family. The cab was spacious, punctual, and made our spiritual journey truly memorable.",
rating: 5
}
];






























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to 5 Jyotirlinga Cab Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-5-jyotirlinga-cab.jpg",
"description": "Book Mumbai to 5 Jyotirlinga cab service for a spiritual pilgrimage tour covering major Jyotirlinga temples. Mumbai Airport Cabs offers comfortable outstation taxis with experienced drivers, flexible tour packages, well-maintained vehicles, and affordable pricing for long-distance religious travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-5-jyotirlinga-cab"
}
};











    return (
        <div>


<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Tour Package Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to 5 Jyotirlinga cab service for a complete pilgrimage tour. Comfortable taxi service with experienced drivers, flexible tour packages, and reliable travel to all major Jyotirlinga temples."
/>

<meta
 name="keywords"
 content="mumbai to 5 jyotirlinga cab, mumbai to 5 jyotirlinga tour package, mumbai to 5 jyotirlinga taxi service, mumbai to 5 jyotirlinga cab service, mumbai to 5 jyotirlinga darshan package, mumbai to 5 jyotirlinga yatra cab, mumbai to 5 jyotirlinga tour cab, mumbai to 5 jyotirlinga taxi, mumbai to 5 jyotirlinga car rental, jyotirlinga tour from mumbai cab, pilgrimage cab mumbai to jyotirlinga, religious tour taxi mumbai, outstation spiritual cab mumbai, temple tour cab mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitofivejyotilingacab;